import React from "react";
import { X } from "lucide-react";

// Linha do que está filtrado agora, com remoção individual. Antes só existia
// "Limpar filtros", tudo ou nada, e pra descobrir o que estava aplicado era
// preciso abrir menu por menu.
export default function ChipsAtivos({ chips, onLimparTudo }) {
  if (!chips || chips.length === 0) return null;
  return (
    <div className="flex flex-wrap items-center gap-1.5" data-e2e="chips-ativos">
      <span className="text-[11px] font-semibold uppercase tracking-wider text-muted-foreground mr-0.5">
        Filtrando por
      </span>
      {chips.map((chip) => (
        <button
          key={chip.id}
          type="button"
          onClick={chip.onRemover}
          data-e2e={`chip-ativo-${chip.id}`}
          className="h-7 pl-2.5 pr-1.5 rounded-full bg-primary/10 border border-primary/30 text-primary text-xs font-semibold flex items-center gap-1 hover:bg-primary/20 transition"
          title="Remover este filtro"
        >
          {chip.rotulo}
          <X className="w-3 h-3" />
        </button>
      ))}
      {chips.length > 1 ? (
        <button
          type="button"
          onClick={onLimparTudo}
          data-e2e="chips-limpar"
          className="h-7 px-2 rounded-full text-xs font-semibold text-muted-foreground hover:text-destructive transition"
        >
          Limpar tudo
        </button>
      ) : null}
    </div>
  );
}
